import React, { useContext } from 'react';
import styled from 'styled-components';
import { Formik } from 'formik';
import { Box } from 'rebass';
import {
  Button, Fieldset, FormGroup, Label, SelectFormExercise,
} from 'components';
import Context from 'stores/context';

const StyledFormEditExercise = styled.div`
  width: 100%;
  margin: 0 auto;

  @media screen and (min-width: 544px) {
    max-width: 480px;
  }

  legend {
    color: #000;
    font-family: 'Gotham';
    font-size: 24px;
    font-weight: 300;
    line-height: 29px;
    text-align: center;
    margin-bottom: 34px;

    @media screen and (min-width: 544px) {
      font-size: 32px;
      line-height: 38px;
    }
  }

  .w-training-main-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 48px;

    > div {
      display: inline-flex;
      width: auto;

      &:first-child {
        @media screen and (min-width: 544px) {
          width: 60px;
        }
      }

      @media screen and (min-width: 544px) {
        max-width: 105px;
      }
    }

    label {
      font-size: 16px;
      line-height: 19px;
      justify-content: center;
      color: #808080;
      text-transform: uppercase;
      padding-left: 0;
      padding-right: 0;
    }
  }

  label {
    font-size: 13px;
    line-height: 16px;
  }

  #intensification_method {
    width: auto;
  }
`;

export const FormEditExercise = ({ updateList }) => {
  const context = useContext(Context);
  const {
    buildTrainingStore,
    modalStore,
    i18n,
    appStore,
  } = context;

  const reloadPostData = () => {
    const {
      values,
      setSubmitting,
    } = appStore.objTemp;

    // eslint-disable-next-line no-use-before-define
    updateIntensificationMethod(values, setSubmitting);
  };

  const updateIntensificationMethod = (values, setSubmitting) => {
    appStore.clearObjTemp();

    const dataCaseTheErroNetwork = {
      values,
      setSubmitting,
    };

    appStore.setObjTemp(dataCaseTheErroNetwork);

    setTimeout(() => {
      buildTrainingStore.clickEditAllItemsSelected([
        { intensification_method: values.intensification_method },
      ]);

      if (buildTrainingStore.hasDiff) {
        buildTrainingStore.doRequestPatchTrainingExercises(
          buildTrainingStore.getExercisesUpdated,
          'intesificaion_method',
        ).then(() => {
          buildTrainingStore.diff = [];
          buildTrainingStore.editAllItemsSelected = [];
          updateList();
          appStore.clearObjTemp();
          modalStore.closeModalError();
          modalStore.toggleModal('modalEditAllExercises', false);
        }).catch((error) => {
          window.scroll(0, 0);
          modalStore.setModalNetworkCallback(reloadPostData);
          modalStore.showModalError(error);
        });
      }

      setSubmitting(false);
    }, 400);
  }

  return (
    <StyledFormEditExercise>
      <Formik
        initialValues={{
          intensification_method: '',
        }}
        onSubmit={(values, { setSubmitting }) => {
          updateIntensificationMethod(values, setSubmitting);
        }}
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
              <Fieldset>
                <div className="w-training-main-info">
                  <FormGroup>
                    <Box m={[3]}>
                      <Label htmlFor="intensification_method">{i18n.t('intensification_method')}</Label>
                      <Box>
                        <SelectFormExercise
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          values={values}
                          listIntensification={buildTrainingStore.intensificationMethods}
                        />
                      </Box>
                    </Box>
                  </FormGroup>
                </div>

                <FormGroup formActions="true" className="w-form-actions" noMarginBottom="true">
                  <Button
                    tertiary="true"
                    color="#d52b1e"
                    onClick={() => {
                      buildTrainingStore.editAllItemsSelected = [];
                      modalStore.toggleModal('modalEditAllExercises', false);
                    }}
                  >
                    {i18n.t('cancel')}
                  </Button>
                  <Button
                    type="submit"
                    primary="true"
                    disabled={isSubmitting}
                  >
                    {i18n.t('saved_update')}
                  </Button>
                </FormGroup>
              </Fieldset>
            </form>
        )}
      </Formik>
    </StyledFormEditExercise>
  );
};

export default FormEditExercise;
